import { Typography } from '@leegality/leegality-react-component-library';
import React from 'react';
import PropTypes from 'prop-types';

const FieldLabel = ({
  name,
  mandatory,
  suffix,
  tag,
  variant,
  fontWeight,
  color,
  className,
}) => (
  <Typography
    tag={tag}
    variant={variant}
    fontWeight={fontWeight}
    color={color}
    className={className}
  >
    {name}
    {mandatory && (
      <Typography
        tag={Typography.Tags.SPAN}
        variant={variant}
        fontWeight={fontWeight}
        color={Typography.Colors.error500}
        className="ml-1"
      >
        *
      </Typography>
    )}
    {suffix && (
      <Typography
        tag={Typography.Tags.SPAN}
        variant={variant}
        color={Typography.Colors.gray500}
        className="ml-1"
      >
        {suffix}
      </Typography>
    )}
  </Typography>
);

FieldLabel.propTypes = {
  name: PropTypes.string,
  mandatory: PropTypes.bool,
  suffix: PropTypes.string,
  tag: PropTypes.string,
  variant: PropTypes.string,
  fontWeight: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};

FieldLabel.defaultProps = {
  name: '',
  mandatory: false,
  suffix: '',
  tag: Typography.Tags.SPAN,
  variant: Typography.Variants.sm,
  fontWeight: Typography.FontWeight.medium,
  color: Typography.Colors.gray700,
  className: '',
};

export default FieldLabel;
